export const environment = {
  production: true,
  public: true,
  baseUrl: "https://webapi.mygift4kids.org",
  recaptchaSiteKey: "6LeeYGoqAAAAAMvKwEMQyCqSsMtp_rOqHZeJvQBL"
};
